var generic = generic || {};
var MantleCarousel = MantleCarousel || {};
var site = site || {};

site.direction = site.direction || {};

(function ($) {
  if (Drupal.behaviors.rangeSliderCarouselV1) {
    return;
  }

  var _get_slide_by_ordinal_index = function ($carousel, ordinal_index) {
    var carousel_slick = MantleCarousel.slick_method($carousel, 'getSlick');
    var $slides = carousel_slick.$slides;
    var $slide = $($slides.get(ordinal_index));

    return $slide;
  };
  var _get_slide_id_by_ordinal_index = function ($carousel, ordinal_index) {
    var $slide = _get_slide_by_ordinal_index($carousel, ordinal_index);

    return $slide.data('range-template-id');
  };
  var _get_ordinal_by_slide_id = function ($carousel, slide_id) {
    var carousel_slick = MantleCarousel.slick_method($carousel, 'getSlick');
    var $slides = carousel_slick.$slides;
    var ordinal_index = null;

    $.each($slides, function (i, obj) {
      if (parseInt($(obj).data('range-template-id')) === parseInt(slide_id)) {
        ordinal_index = i;
      }
    });

    return ordinal_index;
  };
  var _get_ordinal_index = function ($widgetItems) {
    var $activeWidgetItem = $widgetItems.filter('.active');
    var widgetIndex = $widgetItems.index($activeWidgetItem);

    return widgetIndex < 0 ? 0 : widgetIndex;
  };

  Drupal.behaviors.rangeSliderCarouselV1 = {
    isMobile: false,
    attach: function (context) {
      var self = this;
      var $formatters = $('.js-range-slider-carousel', context);
      var breakPoint = Unison.fetch.now().name;

      self.isMobile = breakPoint === 'small';
      Unison.on('change', function (currentBreakPoint) {
        self.isMobile = currentBreakPoint.name === 'small';
        if (breakPoint !== currentBreakPoint.name && breakPoint === 'small' || currentBreakPoint.name === 'small') {
          // we have to reload the formatters if the change was between mobile and other screen size
          self.loopFormatters($formatters, true);
        }
      });
      $formatters.each(function () {
        self.loopFormatters($(this), false);
      });
    },

    loopFormatters: function ($formatters, reloadFormatters) {
      var self = this;

      if (reloadFormatters) {
        $formatters.removeClass('range-carousel-processed');
      }
      $formatters.once('range-carousel').waypoint(function () {
        var $formatter = $(this);

        // load range carousels only on user scroll
        self.load($formatter);
      }, {
        offset: '100%',
        triggerOnce: true
      });
    },

    load: function ($formatter) {
      var self = this;

      $formatter.nodes = {};
      $formatter.data('hideSliderCarousel', $formatter.hasClass('range-slider-carousel--hide-carousel-on-desktop') && !self.isMobile);
      var $sliderWrapper = $('.js-range-slider', $formatter);
      var $slider = $("[type='range']", $sliderWrapper);
      var $content_well = $('.js-range-slider-carousel__content-well', $formatter);
      var $content_well_items = $('.js-basic-carousel__content-well__item', $formatter);

      $formatter.nodes.$carousel = $formatter.data('hideSliderCarousel') ? $() : $('.js-range-slider-carousel__carousel', $formatter);
      var $container = $formatter.closest('.js-mantle-form-options-field');
      var $widgetItems = $('.range-slider-carousel__widget__item', $formatter);
      var widgetInitialIndex = parseInt(_get_ordinal_index($widgetItems));
      var settings = $formatter.nodes.$carousel.data('carousel-settings') || [];
      var slide_selector = settings['slide'];
      var hide_range_slider = $formatter.hasClass('range-slider-carousel--hide-range-slider');
      var reveal_content_well_mode = $formatter.data('content-well-reveal');
      var __carousel_sync_interval = false;

      if (!reveal_content_well_mode) {
        reveal_content_well_mode = 'onload';
      }
      var $slides = $formatter.find('.js-basic-carousel__slide');
      var $view_all_link = $('.js-range-slider-view-all-link', $container);
      var $view_all_content = $('.js-range-slider-view-all-content', $formatter);
      var $contentCarousel = $view_all_content.find('.js-range-slider-carousel');
      var $contentSlick = $('.mantle-carousel.js-range-slider-carousel__carousel', $contentCarousel);
      // Clone the continue button from sticky with its funcionality.
      var $quizLandingFormatter = $formatter.closest('.js-quiz-landing-page-formatter');
      var $stickyFooter = $('.js-quiz-landing-page-footer-cta', $quizLandingFormatter);
      var $continueButton = $('.js-mantle-cta-button', $stickyFooter);
      var $newContinueButton = $continueButton.clone(true);
      var sliderOverlaySettings;
      var initial_slide = $slider.data('starting');

      if (!_.isUndefined(initial_slide)) {
        initial_slide = parseInt(initial_slide);
      } else {
        initial_slide = widgetInitialIndex;
      }

      if ($contentCarousel.length) {
        $view_all_content.append($newContinueButton);
        $newContinueButton.removeClass('button--disabled');
      }

      $view_all_link.once().on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var options = {
          href: $view_all_content,
          className: 'colorbox--quiz colorbox--view-all',
          escKey: false,
          inline: true, // retain state/events
          fixed: true,
          width: '500px'
        };

        options['onComplete'] = function () {
          $view_all_content.on('syn_choice.range-slider', function (e, field_value) {
            var $slider = $("[type='range']", $sliderWrapper);

            $slider.triggerHandler('form-set-values', [field_value]);
            $.colorbox.close();
          });

          $('.js-mantle-cta-button', $view_all_content).on('click.range-slider', function () {
            $.colorbox.close();
          });
          $.colorbox.resize();
          if ($contentCarousel.length) {
            $slides.removeClass('slide-selected-finished slide-selected slick-active slick-center');
            if (MantleCarousel.isCarousel($contentSlick)) {
              MantleCarousel.slick_method($contentSlick, 'unslick');
            }
            sliderOverlaySettings = {
              rtl: site.direction.isRTL,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: false
            };
            if (!MantleCarousel.isCarousel($contentSlick)) {
              MantleCarousel.initializeCarousel($contentSlick, sliderOverlaySettings);
            }
          }
        };

        options['onCleanup'] = function () {
          $view_all_content.off('.range-slider');
        };

        generic.overlay.launch(options);
      });
      // new overlay continue button functionality.
      $view_all_content.on('click', '.js-mantle-cta-button', function (e) {
        e.preventDefault();
        var $clone_button = $(this);
        var $active_button = $clone_button.data('original-button');
        var $cta_button = $('.js-mantle-cta-button', $active_button);

        $cta_button.click();
      });

      var $slider_thumbs = $('.js-slider-thumb', $formatter);

      $formatter.on('slider-percent-change', function (e, percent) {
        var p100 = percent * 100;

        $slider_thumbs.css('left', p100 + '%');
      });

      var updateMode = 'selected';
      var __tickUpdatedTimer;
      var __last_updated_slide;
      var slide_id_ordinal = 0;

      // default the carousel to unselected.
      if ($formatter.data('default-to-unselected')) {
        $slider.attr('data-form-value', '');
      }

      $formatter.nodes.$carousel.on('click', '.slick-slide, .js-basic-carousel__slide', function () {
        var $slide = $(this);

        $slides.removeClass('slide-selected-finished');

        if ($formatter.data('display_content_as_grid_mobile') === 1 && self.isMobile) {
          $slides.removeClass('slide-selected slick-active slick-center');
        }

        // note that range slider doesn't support filtering. So for now, the
        // slide_id is the actual ordinal index
        var slide_id = $slide.data('range-template-id');

        // set the slider. this is how form options fields get it's values.
        $slider.trigger('slide-to', [slide_id, 0, false]);
        // notify form options field that the ticket is set
        $formatter.trigger('slider-tick-set', slide_id);

        // Handle the case where we are loading carousel and nothing is clicked.
        if (!$formatter.hasClass('slide-active') && $slide.hasClass('slick-center') && $formatter.data('display_content_as_grid_mobile') === 0) {
          slide_id_ordinal = _get_ordinal_by_slide_id($formatter.nodes.$carousel, slide_id);
          _fake_slide_goto_render(slide_id_ordinal);
        } else {
          $slide.addClass('slide-selected-finished');
          $slide.addClass('slide-selected');
          if ($formatter.data('display_content_as_grid_mobile') === 1 && self.isMobile) {
            $slide = $formatter.nodes.$carousel.find(slide_selector + "[data-range-template-id='" + slide_id + "']");
            $slide.addClass('slide-selected-finished slide-selected');
          }
        }
      });

      $slider.on('slider-tick-set', function (e) {
        // we want to handle this in form_options_field
        e.stopPropagation();
      });

      $slider.on('tick-updated', function (event, tick_num) {
        var currentSlide = parseInt(MantleCarousel.currentSlide($formatter.nodes.$carousel));

        tick_num = parseInt(tick_num);
        if (__last_updated_slide === tick_num) {
          return;
        }
        __last_updated_slide = tick_num;

        // for quick drag, we need to wait for it to stop
        window.clearInterval(__tickUpdatedTimer);
        __tickUpdatedTimer = window.setInterval(function () {
          currentSlide = parseInt(MantleCarousel.currentSlide($formatter.nodes.$carousel));
          // don't run at the same time. return and don't clear interval
          if ($formatter.nodes.$carousel.hasClass('carousel-sliding')) {
            return;
          }
          if (currentSlide !== tick_num) {
            var skip_animation = false;

            __last_updated_slide = null;
            $formatter.nodes.$carousel.data('slider-request', true);
            $formatter.trigger('carousel_goto', [tick_num, skip_animation]);
          }
          window.clearInterval(__tickUpdatedTimer);
        }, 50);
      });

      $slider.on('tick-selected', function (event, tick_num) {
        // tick selected. No reason to use delayed udpated behavior
        window.clearInterval(__tickUpdatedTimer);
        $formatter.trigger('select-slide', [tick_num, false, true]);
      });

      // Init this carousel with our settings
      if (!_.isUndefined(initial_slide)) {
        settings['initialSlide'] = initial_slide;
        _.forEach(settings.responsive, function (info) {
          info.settings['initialSlide'] = initial_slide;
        });
      }
      settings['rtl'] = site.direction.isRTL;

      var unslickCarouselGrid = function ($formatter) {
        if ($formatter.data('display_content_as_grid_mobile') === 1 && self.isMobile) {
          if (MantleCarousel.isCarousel($formatter.nodes.$carousel)) {
            MantleCarousel.slick_method($formatter.nodes.$carousel, 'unslick');
          }
        }
      };

      // this will reslick carousel. It will unslick if carousel arleady exists
      $formatter.on('reslick-carousel', function () {
        if ($formatter.nodes.$carousel.length < 1) {
          return;
        }
        if (MantleCarousel.isCarousel($formatter.nodes.$carousel)) {
          MantleCarousel.slick_method($formatter.nodes.$carousel, 'unslick');
        }

        MantleCarousel.initializeCarousel($formatter.nodes.$carousel, settings);
        unslickCarouselGrid($formatter);
      });

      $formatter.trigger('reslick-carousel');

      var select_widget_item = function (target_id) {
        // have to recall the interval to center with the active widgetItem
        // can't use slickGoTo as it fails
        if (!$formatter.data('hideSliderCarousel') && typeof __call_sync_interval === 'function') {
          __call_sync_interval();
        }

        if ($widgetItems.length < 1) {
          return;
        }
        $widgetItems.removeClass('active');
        $widgetItems.each(function (i, obj) {
          var $item = $(obj);
          var slide_id = parseInt($item.data('range-template-id'));

          if (slide_id === parseInt(target_id)) {
            $item.addClass('active');
          }
        });
      };

      if (!$formatter.data('default-to-unselected')) {
        if (!_.isUndefined(initial_slide)) {
          select_widget_item(initial_slide);
        } else {
          select_widget_item(widgetInitialIndex);
        }
      }

      $widgetItems.on('click', function () {
        var $item = $(this);
        var slide_id = $item.data('range-template-id');

        $formatter.trigger('select-slide-by-id', [slide_id, true, true]);
      });

      // Filter items. This will currently handle the widget items and main carousel.
      $formatter.on('rsc:filter-items', function (e, filter_selector) {
        $formatter.nodes.$carousel.slickUnfilter();
        $formatter.nodes.$carousel.slickFilter(filter_selector);

        // Filter widget items
        $widgetItems.each(function (i, obj) {
          var $item = $(obj);

          // hiding the slide messes up carousels.
          // so make sure we're not modifying slide items
          if ($item.closest('.slick-slider').length > 0) {
            return;
          }

          if ($item.is(filter_selector)) {
            $item.removeClass('shade-finder-hidden');
          } else {
            $item.addClass('shade-finder-hidden');
          }
        });

        var $active_item = $widgetItems.filter('.active');

        // If the active item is hidden. let's activate the first shade that
        // is remaining.
        if ($active_item.hasClass('shade-finder-hidden')) {
          $active_item.removeClass('active');
          var $new_active = $widgetItems.not('.shade-finder-hidden').first();

          $new_active.click();
        } else if (!$formatter.data('hideSliderCarousel')) {
          // have to recall the interval to center with the active widgetItem
          // can't use slickGoTo as it fails
          __call_sync_interval();
        }
      });

      var content_well_settings = {
        rtl: site.direction.isRTL,
        slide: '.js-basic-carousel__content-well__item',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        rows: 0
      };

      if (!_.isUndefined(initial_slide)) {
        content_well_settings['initialSlide'] = initial_slide;
      }

      if (reveal_content_well_mode === 'onload' && !$content_well.hasClass('slick-initialized') && ($content_well_items.length > 0)) {
        MantleCarousel.initializeCarousel($content_well, content_well_settings);
      }

      var __current_slide_id;
      /**
        * Certain functionality is tied to before/afterChange events. One
        * of the issues is that if SlickCarousel is set to move to the same
        * slide, it will not trigger those events. If this happens, we need to
        * know so that we can trigger the before/after handlers directly.
        */
      var _need_to_fake_slide_goto = function (slide_num) {
        // No carousel anyways.
        if (!MantleCarousel.isCarousel($formatter.nodes.$carousel)) {
          return true;
        }

        var currentSlide = parseInt(MantleCarousel.currentSlide($formatter.nodes.$carousel));

        if (currentSlide === parseInt(slide_num)) {
          return true;
        }
        var slide_id = parseInt(_get_slide_id_by_ordinal_index($formatter.nodes.$carousel, slide_num));

        if (slide_id === parseInt(__current_slide_id)) {
          return true;
        }

        return false;
      };
      var _fake_slide_goto_render = function (slide_num) {
        // fake the before/after event handers for slick
        _slide_selected_before(slide_num, slide_num);
        _slide_selected_after(slide_num);
        MantleCarousel.set_carousel_active_classes($formatter.nodes.$carousel);
      };

      $formatter.on('carousel_goto', function (event, slide_num, skip_animation) {
        var slide_id = _get_slide_id_by_ordinal_index($formatter.nodes.$carousel, slide_num);
        var need_fake_slide = _need_to_fake_slide_goto(slide_num);

        if (!need_fake_slide) {
          if (MantleCarousel.isCarousel($formatter.nodes.$carousel)) {
            MantleCarousel.slideTo($formatter.nodes.$carousel, slide_num, skip_animation);
          }
          if (MantleCarousel.isCarousel($content_well)) {
            MantleCarousel.slideTo($content_well, slide_num, true);
          }

          select_widget_item(slide_id);
        } else {
          _fake_slide_goto_render(slide_num);
        }
      });

      // Sometimes jcarousel just ignores slickGoto if you do them too fast.
      // this will make sure the carousel corrects itself.
      var __call_sync_interval = function () {
        if (__carousel_sync_interval !== false) {
          return;
        }
        __carousel_sync_interval = window.setInterval(function () {
          if ($formatter.nodes.$carousel.hasClass('carousel-sliding') || $formatter.data('hideSliderCarousel')) {
            return;
          }
          if (__current_slide_id === null) {
            MantleCarousel.slideTo($formatter.nodes.$carousel, 0);

            return;
          }
          var currentSlide = MantleCarousel.currentSlide($formatter.nodes.$carousel);
          var currentSlideId = _get_slide_id_by_ordinal_index($formatter.nodes.$carousel, currentSlide);

          if (parseInt(currentSlideId) !== parseInt(__current_slide_id)) {
            var current_slide_id_ordinal = _get_ordinal_by_slide_id($formatter.nodes.$carousel, __current_slide_id);

            // if current_slide_id is no longer seen
            if (current_slide_id_ordinal === null) {
              return;
            }
            MantleCarousel.slideTo($formatter.nodes.$carousel, current_slide_id_ordinal);
            clearInterval(__carousel_sync_interval); // clear the interval after the load was complete
            __carousel_sync_interval = false;
          }
        }, 200);
      };

      if (!$formatter.data('hideSliderCarousel')) {
        __call_sync_interval();
      }
      $content_well.once().on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        __current_slide_id = _get_slide_id_by_ordinal_index($content_well, nextSlide);
        $formatter.addClass('slide-active');
        if (parseInt(currentSlide) !== parseInt(nextSlide)) {
          // we requested to slide to the same slide.
          // dont unset sku toggles.
          return;
        }
        var $old_slide = $content_well.find(".js-basic-carousel__content-well__item[data-range-template-id='" + currentSlide + "']");

        $('.sku-toggle', $old_slide).addClass('hidden');
      });

      var _slide_selected_before = function (currentSlide, nextSlide) {
        var nextSlideId = _get_slide_id_by_ordinal_index($formatter.nodes.$carousel, nextSlide);
        var $slide = $formatter.find(slide_selector + "[data-range-template-id='" + nextSlideId + "']");

        if (parseInt(currentSlide) !== parseInt(nextSlide)) {
          $formatter.nodes.$carousel.find(slide_selector).removeClass('slide-selected');
          $formatter.nodes.$carousel.find(slide_selector).removeClass('slide-selected-finished');
        }
        $slide.addClass('slide-selected');
        $formatter.addClass('slide-active');
      };
      var _slide_selected_after = function (currentSlide) {
        var currentSlideId = _get_slide_id_by_ordinal_index($formatter.nodes.$carousel, currentSlide);
        var $slide = $formatter.find(slide_selector + "[data-range-template-id='" + currentSlideId + "']");

        $slide.addClass('slide-selected-finished');
      };

      $formatter.nodes.$carousel.once('event-listeners').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        // only slide to if we're not interactive with slider.
        if (!$formatter.nodes.$carousel.data('slider-request')) {
          $formatter.trigger('slide-range-input', [nextSlide, 500, false]);
        }

        __current_slide_id = _get_slide_id_by_ordinal_index($formatter.nodes.$carousel, nextSlide);
        var $old_slide = $formatter.find(slide_selector + "[data-range-template-id='" + currentSlide + "']");

        $('.sku-toggle', $old_slide).addClass('hidden');

        _slide_selected_before(currentSlide, nextSlide);
        $formatter.nodes.$carousel.addClass('carousel-sliding');

        $formatter.trigger('select-slide-by-ordinal', [nextSlide, false, false]);
      }).on('afterChange', function (event, slick, currentSlide) {
        $formatter.nodes.$carousel.removeClass('carousel-sliding');
        $formatter.nodes.$carousel.data('slider-request', false);
        _slide_selected_after(currentSlide);

        // update input after first interaction
        if (updateMode === 'selected') {
          var input_val = $slider.triggerHandler('get-slider-val');

          $formatter.trigger('slider-tick-set', input_val);
        }
      });

      var _skuToggle = function ($item, sku_id) {
        var $sku_toggles = $('.sku-toggle', $item);

        $sku_toggles.addClass('hidden');
        var $valid = $sku_toggles.filter('[data-sku-base-id="' + sku_id + '"]');

        $valid.removeClass('hidden');
      };

      $formatter.once('event-listeners').on('product.skuSelect', function (event, sku_id) {
        $formatter.trigger('skuToggle', [sku_id, __current_slide_id]);
      }).on('skuToggle', function (event, sku_id, target_slide_id) {
        if (!target_slide_id) {
          target_slide_id = 0;
        }
        var $content_well_item = $(".js-basic-carousel__content-well__item[data-range-template-id='" + target_slide_id + "']", $formatter);

        _skuToggle($content_well_item);
        var $slide = $formatter.find(slide_selector + "[data-range-template-id='" + target_slide_id + "']");

        _skuToggle($slide);
      }).on('slide-range-input', function (event, target_slide, duration, step_check) {
        // if hidden. do need to animate
        if (hide_range_slider) {
          $slider.trigger('slide-to', [target_slide, 0, false]);

          return;
        }
        $slider.trigger('slide-to', [target_slide, duration, step_check]);
      }).on('select-slide-by-ordinal', function (event, target_slide, sync_slider, sync_carousel) {
        /*
        * When we are filtering carousels. We need to translation
        * range-template-id to the ordinal index.
        */
        if ($formatter.data('hideSliderCarousel')) {
          return;
        }
        var carousel_slick = MantleCarousel.slick_method($formatter.nodes.$carousel, 'getSlick');
        var $slides = carousel_slick.$slides;
        var $slide = $($slides.get(target_slide));
        var target_id = $slide.data('range-template-id');

        $formatter.trigger('select-slide', [target_slide, sync_slider, sync_carousel, target_id]);
      }).on('select-slide-by-id', function (event, target_slide, sync_slider, sync_carousel) {
        if (!$content_well.hasClass('slick-initialized') && ($content_well_items.length > 0) && !$formatter.data('hideSliderCarousel')) {
          MantleCarousel.initializeCarousel($content_well, content_well_settings);
        }
        var ordinal_index = !$formatter.data('hideSliderCarousel') ? _get_ordinal_by_slide_id($formatter.nodes.$carousel, target_slide) : 0;

        if (!_.isNull(ordinal_index)) {
          $formatter.trigger('select-slide', [ordinal_index, sync_slider, sync_carousel, target_slide]);
        }
      }).on('select-slide', function (event, target_slide, sync_slider, sync_carousel, target_slide_id) {
        if (!$content_well.hasClass('slick-initialized') && ($content_well_items.length > 0) && !$formatter.data('hideSliderCarousel')) {
          MantleCarousel.initializeCarousel($content_well, content_well_settings);
        }

        var $content_well_item = $(".js-basic-carousel__content-well__item[data-range-template-id='" + target_slide_id + "']", $formatter);

        if ($content_well.hasClass('slick-initialized')) {
          MantleCarousel.slideTo($content_well, target_slide, true);
        }
        select_widget_item(target_slide_id);

        var $triggerable_sku = $('.js-product[data-trigger-sku-select="1"]', $content_well_item);

        if ($triggerable_sku && $triggerable_sku.data('sku-base-id')) {
          var sku_id = $triggerable_sku.data('sku-base-id');

          $triggerable_sku.trigger('product.shadeSelect', [sku_id]);
          $formatter.trigger('skuToggle', [sku_id, target_slide]);
        }

        if (sync_slider) {
          $formatter.trigger('slide-range-input', [target_slide, 500, false]);
        }
        // turn off auto change udpates
        if (sync_carousel && !$formatter.data('hideSliderCarousel')) {
          $formatter.nodes.$carousel.data('slider-request', true);
          $formatter.trigger('carousel_goto', [parseInt(target_slide)]);
        }
      });
    }
  };
})(jQuery);
